import { noAuthRequest } from "@/services/index";

export async function setEmail(email) {
  return await noAuthRequest("POST", "forget-password", email);
}

export async function setCode(data) {
  return await noAuthRequest("POST", "valid-token", data);
}
export async function setNewPassword(data) {
  return await noAuthRequest("POST", "reset-password", data);
}
